const MoneyIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.5002 13.5H13.5002C11.2911 13.5 9.50024 15.2909 9.50024 17.5V30.5C9.50024 32.7091 11.2911 34.5 13.5002 34.5H34.5002C36.7094 34.5 38.5002 32.7091 38.5002 30.5V17.5C38.5002 15.2909 36.7094 13.5 34.5002 13.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M28.5 23.9998C28.5 27.5896 26.4853 30.4998 24 30.4998C21.5147 30.4998 19.5 27.5896 19.5 23.9998C19.5 20.4099 21.5147 17.4998 24 17.4998C26.4853 17.4998 28.5 20.4099 28.5 23.9998Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M10.5 28.5C13.2614 28.5 15.5 30.7386 15.5 33.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M37.4998 28.5C34.7383 28.5 32.4998 30.7386 32.4998 33.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M10.5 19.4998C13.2614 19.4998 15.5 17.2612 15.5 14.4998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M37.4998 19.4998C34.7383 19.4998 32.4998 17.2612 32.4998 14.4998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  )
}

export default MoneyIcon
